import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { UserAuthGuard } from './_routeguards/user.authguard';

const appRoutes: Routes = [
     {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [UserAuthGuard]
    }
];

export const routes = RouterModule.forRoot(appRoutes, {});
